import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node,
  isDecorative: PropTypes.bool,
  state: PropTypes.oneOf(['', 'bounce-back-rewards', 'tier1-gift']),
  theme: PropTypes.oneOf(['', 'inverse'])
};
function GraphicBadge(_ref) {
  var _ref$isDecorative = _ref.isDecorative,
    isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? '' : _ref$state,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? '' : _ref$theme;
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": isDecorative,
    className: "graphic-badge",
    "data-state": state || null,
    "data-testid": "graphic-badge",
    "data-theme": theme || null
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "graphic-badge-inner",
    "data-testid": "graphic-badge-inner"
  }, children && /*#__PURE__*/React__default.createElement("span", {
    className: "graphic-badge-value",
    "data-testid": "graphic-badge-value"
  }, children)));
}
GraphicBadge.propTypes = propTypes;

export { GraphicBadge as default };
//# sourceMappingURL=GraphicBadge.js.map
